import React from "react";

const PartnerTerms = () => {
  return (
    <div
      style={{
        padding: "40px",
        
        margin: "auto",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
        color: "#333",
      }}
    >
      <h1 style={{ fontSize: "32px", marginBottom: "30px" }}>
        Terms & Conditions for Partner Registration
      </h1>

      <h2 style={{ fontSize: "24px", marginTop: "30px" }}>1. Eligibility & Registration</h2>
      <ul>
        <li>You must be the owner, manager, or legal representative of the property.</li>
        <li>You must provide accurate legal documents (property ownership, license, CNIC, tax registration, etc.).</li>
        <li>All information submitted must be true and verifiable.</li>
        <li>Yovho reserves the right to accept or reject any registration without explanation.</li>
      </ul>

      <h2 style={{ fontSize: "24px", marginTop: "30px" }}>2. Property Verification & Agreement</h2>
      <ul>
        <li>All properties must go through physical inspection by Yovho's verification team.</li>
        <li>Your listing will only go live after approval and signing a service agreement.</li>
        <li>
          We check:
          <ul>
            <li>All rooms, washrooms, kitchens, and entrances</li>
            <li>Cleanliness, hygiene, privacy, and guest safety</li>
            <li>Compliance with local tourism and safety regulations</li>
          </ul>
        </li>
        <li>We reserve the right to revisit, inspect, or suspend listings at any time.</li>
      </ul>

      <h2 style={{ fontSize: "24px", marginTop: "30px" }}>3. Commission & Payments</h2>
      <ul>
        <li>Yovho charges an 8% commission on each successful booking.</li>
        <li>Payouts will be made to partners via bank transfer after guest checkout, within 29 days.</li>
      </ul>

      <h2 style={{ fontSize: "24px", marginTop: "30px" }}>4. Listing Content & Restrictions</h2>
      <ul>
        <li>All property images, descriptions, and facilities must be accurate and real.</li>
        <li>
          You are not allowed to host parties, unmarried couples, or unsafe activities under Yovho bookings.
        </li>
        <li>Yovho reserves the right to edit or remove content that violates our brand standards.</li>
      </ul>

      <h2 style={{ fontSize: "24px", marginTop: "30px" }}>5. Conduct & Service Standards</h2>
      <ul>
        <li>All staff at your property must be trained, respectful, and professionally dressed.</li>
        <li>Your property must maintain:</li>
        <ul>
          <li>Daily cleanliness</li>
          <li>24/7 guest support</li>
          <li>No hidden surveillance</li>
          <li>Safe and peaceful environment</li>
        </ul>
        <li>Random inspections will be done to ensure service levels are maintained.</li>
      </ul>

     
    </div>
  );
};

export default PartnerTerms;
